var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"Icon",class:_vm.iconClasses,attrs:{"alt":"","aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#Icon--' + _vm.symbol}})])
}
var staticRenderFns = []

export { render, staticRenderFns }